import { API } from "../../../globals/globals";
import { useGetStatusQuery } from "../../../store/api/admin/adminApiSlice";

export const useGeoRedundancy = () => {

    const { data, isLoading, error } = useGetStatusQuery(undefined, {
        pollingInterval: API.ENDPOINTS.STATUS.pollingInterval,
    });

    return {
        data,isLoading,error
    }
}